import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
function VideoPlayer({
  src
}: {
  src: string;
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const handlePlay = () => {
    if (!isLoaded) {
      setIsLoaded(true);
      setIsPlaying(true);
      return;
    }
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  return <div className="relative aspect-[9/16] bg-black rounded-xl sm:rounded-2xl overflow-hidden shadow-lg group cursor-pointer w-full max-w-sm mx-auto" onClick={handlePlay} data-id="element-146" data-mp="9vn4xjvz06i0">
      {!isLoaded ? <>
          <video src={`${src}#t=0.1`} className="w-full h-full object-cover opacity-70" playsInline preload="metadata" muted data-id="element-147" data-mp="12kakqzxya3o6" />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-148" data-mp="17dvlgzqxhbr2">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/90 rounded-full flex items-center justify-center shadow-xl transform group-hover:scale-110 transition-transform" data-id="element-149" data-mp="3avtqlolf6n7u">
              <PlayIcon className="w-6 h-6 sm:w-8 sm:h-8 text-[#FF6B8A] ml-1" data-id="element-150" data-mp="3pmar95q8d93o" />
            </div>
          </div>
        </> : <video ref={videoRef} src={src} className="w-full h-full object-cover" playsInline loop autoPlay onEnded={() => setIsPlaying(false)} onPause={() => setIsPlaying(false)} onPlay={() => setIsPlaying(true)} data-id="element-151" data-mp="2fi3pkapph55" />}

      {isLoaded && !isPlaying && <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-152" data-mp="ccmszszutsq6">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/90 rounded-full flex items-center justify-center shadow-xl transform group-hover:scale-110 transition-transform" data-id="element-153" data-mp="7crzrislwr1y">
            <PlayIcon className="w-6 h-6 sm:w-8 sm:h-8 text-[#FF6B8A] ml-1" data-id="element-154" data-mp="297snod2e82yh" />
          </div>
        </div>}
    </div>;
}
export function QualityVideoSection() {
  return <section className="py-12 md:py-16 px-4 bg-white" data-id="element-155" data-mp="32vfb0anfkskl">
      <div className="max-w-4xl mx-auto" data-id="element-156" data-mp="32y1fu2ixstz4">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-8" data-id="element-157" data-mp="37uievrrocsqz">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2D2D3F] mb-3" data-id="element-158" data-mp="3hsza50xnbtiu">
            Disney Coloring Packs
          </h2>
          <p className="text-[#6B7280] text-base sm:text-lg max-w-2xl mx-auto" data-id="element-159" data-mp="3qlt4m5lnyzha">
            Mirá cómo se ven las páginas por dentro antes de elegir tu pack.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="flex justify-center" data-id="element-160" data-mp="4ebepv8gxdmy">
          <VideoPlayer src="https://cdn.magicpatterns.com/uploads/k6TtAvJkUPrdMsjLsB6M7Y/IMG_7193.MOV" data-id="element-161" data-mp="1ttdnxxze8l0c" />
        </motion.div>
      </div>
    </section>;
}